import Button from '@/components/Button'
import { assetUrl } from '@/utils/asset-url'
import { isAgentPrincipalEnabled } from '@/hooks/use-use-cases/index'
import { useNavigate } from '@/lib/router-dom'
import classname from 'classnames'
import { PropTypes } from 'prop-types'
import { useState } from 'react'
import MultiClamp from 'react-multi-clamp'
import Tags from '@/componentsDS/Tags/Tags';

const Status = {
	DEFAULT: 'not-enrolled',
	ENROLLED: 'enrolled',
	PENDING: 'pending',
	NOTENROLLED: 'NOT_ENROLLED',
	REJECTED: 'REJECTED'

}

const userTypes = {
	participant: "participant",
	admin: "admin",
	nonParticipant: "nonParticipant"
}

const CardUseCase = ({ id, title, image, description, status, agentStatus, role, handleSelect, select, enableETR }) => {
	const { goTo } = useNavigate()
	const [loading] = useState(true)
	const isAgent = isAgentPrincipalEnabled(agentStatus)

	const cardClass = classname({
		'card': true,
	})

	function goToDashboard(useCaseId) {
		goTo(`/use-cases/${useCaseId}/dashboard`)
	}

	function goToPersonaEnroll(useCaseId) {
		goTo(`/use-cases/${useCaseId}/personas`)
	}

	function goToEtrIssuancePersonaEnroll(useCaseId) {
		goTo(`/use-cases/etr-issuance/${useCaseId}/personas`)
	}

	function goToEnroll(useCaseId) {
		sessionStorage.removeItem('personaItems')
		sessionStorage.setItem("useCaseDetails", JSON.stringify(useCaseId))
		goTo(`/use-cases/enrol/sgtradex`)
	}

	function goToViewInfo(useCaseId) {
		goTo(`/use-cases/${useCaseId}`)
	}
	return (
		<div className={cardClass}>
			<div className="card__header">
				<div className="card__header__title"><MultiClamp clamp={4}>{title}</MultiClamp></div>
				<div className="card__header__gfx"><img src={assetUrl(image)} /></div>
				<div className="card__header__tags">
					{status === Status.ENROLLED && (
						<>
							<Tags label="Enrolled" tagClassName='DS__tag--success'/>
							{isAgent && (
								<Tags label="Enabled Agent Principal" tagClassName='DS__tag--system'/>
							)}
						</>
					)}
					{status === Status.PENDING && (
						<Tags label="Requested" tagClassName='DS__tag--warning'/>
					)}
				</div>
			</div>
			<div className="card__content">
				<div className="card__content__desc">
					<MultiClamp clamp={8}>{description}</MultiClamp>
				</div>
				<div className="card__content__info">
					<div className="card__info">
						<div className="card__info__cols">
						</div>
					</div>
				</div>
				<div className="card__content__footer">
					<div className="card__content__footer__cols">
						{(status === undefined || status === null) && (
							<>
								<div className="card__content__footer__col">
									<Button loading={loading} full round disabled={true} />
								</div>
							</>
						)}

						{status === Status.ENROLLED && (
							<>
								<div className="card__content__footer__col">
									<Button text="More Info" id="use-case-view-details" ghost noborder round submit={() => goToViewInfo(id)} />
								</div>
								<div className="card__content__footer__col">
									<Button text="Manage" id="use-case-view-dashboard-button" full round submit={() => goToDashboard(id)} />
								</div>
							</>
						)}

						{status === Status.DEFAULT && role !== 'admin' && (
							<>
								<div className="card__content__footer__col">
									<Button text="More Info" id="use-case-view-details" ghost noborder round submit={() => goToViewInfo(id)} />
								</div>
								<div className="card__content__footer__col">
									<Button text="Enroll" id="enroll-use-case-button" full round submit={() =>{
										enableETR ? goToEtrIssuancePersonaEnroll(id) : goToPersonaEnroll(id)}} />
								</div>
							</>
						)}

						{status === Status.PENDING && role !== 'admin' && (
							<>
								<div className="card__content__footer__col">
									<Button text="More Info" id="use-case-view-details" ghost noborder round submit={() => goToViewInfo(id)} />
								</div>
								<div className="card__content__footer__col">
									<Button text="Manage" round disabled={true} full />
								</div>
							</>
						)}

						{
						status === Status.DEFAULT && role === 'admin' && (
							<>
								{id !== select.useCaseId && (
									<div className="card__content__footer__col">
										<Button text="Select" full round ghost submit={handleSelect} />
									</div>
								)}
								{id === select.useCaseId && select.selected === true && (
									<div className="card__content__footer__col">
										<Button text="Selected" full round submit={handleSelect} />
									</div>
								)}
							</>
						)}

						{status !== Status.NOTENROLLED && status !== Status.REJECTED && role === userTypes.nonParticipant && (

							<>
								<div className="card__content__footer__col">
									<Button text="More Info" id="use-case-view-details" ghost noborder round submit={() => goToViewInfo(id)} />
								</div>
							</>
						)}

						{(status === Status.NOTENROLLED || status === Status.REJECTED) && role === userTypes.nonParticipant && (

							<>
								<div className="card__content__footer__col">
									<Button text="More Info" id="use-case-view-details" ghost noborder round submit={() => goToViewInfo(id)} />
								</div>
								<div className="card__content__footer__col">
									<Button text="Enroll" id="enroll-into-sgtradex-button" full round submit={() => goToEnroll(id)} />
								</div>
							</>
						)}

					</div>
				</div>
			</div>
		</div >
	)
}

CardUseCase.propTypes = {
	id: PropTypes.string,
	title: PropTypes.string,
	image: PropTypes.string,
	description: PropTypes.string,
	status: PropTypes.string,
	agentStatus: PropTypes.string,
	role: PropTypes.string,
	handleSelect: PropTypes.func,
	select: PropTypes.object,
	enableETR: PropTypes.bool
}

export default CardUseCase
